const formatCurrency = (n) => n

export default formatCurrency
